export type ShareDataProps = {
	title: string;
	text: string;
	url?: string;
	files?: File[];
	fallbackType?: 'telegram' | 'email' | 'whatsapp'; // optional, no default
};

export const handleShare = async (
	{
		title,
		text,
		url,
		files,
		fallbackType = 'whatsapp'
	}: ShareDataProps) => {
	const fullText = `${text}\n${url}`;
	
	const shareData: ShareData = {
		title,
		text: fullText // ⬅️ URL is now only here
	};
	
	if (files?.length && 'canShare' in navigator && navigator.canShare({files})) {
		Object.assign(shareData, {files});
	}
	
	try {
		if ('share' in navigator) {
			await navigator.share(shareData);
		} else {
			throw new Error('navigator.share not supported');
		}
	} catch (error: any) {
		if (error.name !== 'AbortError') {
			const encodedBody = encodeURIComponent(`${title}\n${fullText}`);
			let fallbackUrl = '';
			
			switch (fallbackType) {
				case 'telegram':
					fallbackUrl = `https://t.me/share/url?text=${encodedBody}`;
					break;
				case 'email':
					fallbackUrl = `mailto:?subject=${encodeURIComponent(title)}&body=${encodedBody}`;
					break;
				case 'whatsapp':
				default:
					fallbackUrl = `https://wa.me/?text=${encodedBody}`;
					break;
			}
			
			window.open(fallbackUrl, '_blank');
		}
	}
};
